import { render, staticRenderFns } from "./ItemMoudle.vue?vue&type=template&id=c888ce4e&scoped=true&"
import script from "./ItemMoudle.vue?vue&type=script&lang=js&"
export * from "./ItemMoudle.vue?vue&type=script&lang=js&"
import style0 from "./ItemMoudle.vue?vue&type=style&index=0&id=c888ce4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c888ce4e",
  null
  
)

export default component.exports